import { FC, useState } from "react";
import Popup from "../../Popup/Popup";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { Stack, Text } from "@fluentui/react";
import "./index.css";
import { useAppDispatch } from "../../../hooks/hooks";
import {
  deleteDocument,
  getProjectDocuments,
} from "../../../modules/redux/Documents/document";
import Loader from "../../Loader";
import { t } from "i18next";
import { Trans } from "react-i18next";
import ErrorIcon from "../../../assets/Icons/svg/errorIcon";
import SuccessIcon from "../../../assets/Icons/svg/successIcon";
import DeleteIcon from "../../../assets/Icons/svg/deleteIcon";

const DeleteDocumentModal: FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const [modal, setModal] = useState<boolean>(false);
  const [upload, setUpload] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const handleDeleteClick = () => {
    if (props.rootDocumentId) {
      setModal(true);
      dispatch(deleteDocument(props.rootDocumentId)).then((res: any) => {
        setUpload(true);
        if (res.meta.requestStatus === "fulfilled") {
          setMessage("Success");
          setTimeout(() => {
            props.refresh?.();
            if (props.projectId) {
              dispatch(getProjectDocuments(props.projectId));
            }
            props.hideModal();
          }, 2000);
        } else {
          setMessage("Error");
        }
        setTimeout(() => {
          disable();
        }, 3000);
      });
    }
  };


  function disable() {
    props.hideModal();
    setModal(false);
    setUpload(false);
    setMessage("");
  }

  const icon = !upload ? <DeleteIcon /> : message === "Success" ? <SuccessIcon /> : <ErrorIcon />;

  const customContent = (
    <VerticalStack
      className="deleteContainer"
      style={{ minHeight: !modal ? "277px" : "100px" }}
    >
      {modal ? (
        <>
          <VerticalStack
            style={{
              alignItems: upload ? "" : "center",
              justifyContent: upload ? "" : "space-between",
              backgroundColor: "",
              gap: "20px",
              padding: "20px 25px",
              width: "100%",
            }}
          >
            {!upload ? <Loader /> : null}
            <Text
              style={{
                fontSize: "17px",
              }}
              className="deleteContentText"
            >
              {upload ? (
                <Text className="deleteContentText">
                  {`${props?.documentName}`} {t("deleted")}
                </Text>
              ) : (
                <Text className="deleteContentText">
                  {t("deleting")} {`${props?.documentName}`}
                </Text>
              )}
            </Text>
          </VerticalStack>
        </>
      ) : (
        <>
          <VerticalStack style={{ padding: "20px 25px", gap: "20px" }}>
            <div className="popup-content-icon" style={{margin: "0"}}>{icon}</div>
            <Text className="deleteContentText">
              {t("delete_conf")}&nbsp;<b>{props?.documentName}</b> {t("delete_docFamily")} ?
            </Text> 
            <p className="deleteContentText1">
              <Trans i18nKey="delete_doc_warning" />
            </p>
          </VerticalStack>
          <Stack className="horizontalLine"></Stack>
          <HorizontalStack
            className="deleteBottom"
            style={{ padding: "20px 25px" }}
          >
            <Text className="deleteCancelButton" onClick={props.hideModal}>
              {t("cancel")}
            </Text>
            <Text className="deleteButton" onClick={handleDeleteClick}>
              {t("delete")}
            </Text>
          </HorizontalStack>
        </>
      )}
    </VerticalStack>
  );

  return (
    <Popup
      isOpen={props.isModalOpen}
      title={
        upload
          ? message === "Success"
            ? t("success")
            : t("error")
          : t("delete_document")
      }
      iconName={null}
      contentTitle={upload ? t("success") : t("error")}
      content={upload ? t("success") : t("error")}
      onClose={modal ? disable : props.hideModal}
      customContent={customContent}
      showCloseButton={!modal}
      width="480px"
      minHeight={modal ? "100px" : "277px"}
      backgroundColor={
        upload && message === "Success"
          ? "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)"
          : "#FCF0ED"
      }
    />
  );
};

export default DeleteDocumentModal;
